export default {"src":"/_next/static/media/capers.95b88d82.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};